import React, { PureComponent, PropTypes } from 'react';
import { camelizeKeys } from 'humps';
import { callApi } from '../../../middleware/api';

import Loader from '../../../components/Loader';
import { formatDate } from '../../../utils/date';



export default class InvoiceContainer extends PureComponent {
  static contextTypes = {
    company: PropTypes.object.isRequired
  };

  state = {
    companyId: null,
    loading: true,
    items: null
  };

  loadInvoices = (companyId) => {
    callApi(`invoices/${companyId}/`)
      .then(
        ({results}) => {
          this.setState({
            loading: false,
            companyId,
            items: camelizeKeys(results)
          });
        },
        error => alert("Kļūda")
      );
  };

  componentWillMount() {
    const { company: {id} } = this.context;
    this.loadInvoices(id);
  }

  componentWillReceiveProps(nextProps, nextContext) {
    if (nextContext.company.id !== this.state.companyId) {
      this.loadInvoices(nextContext.company.id);
    }
  }

  render() {
    const { items, loading } = this.state;
    return (
      <div className="container mt-5">
        <h1 className="mb-5">Rēķini <small className="text-muted">pēdējo 12 mēnešu laikā</small></h1>
        <Loader loaded={!loading}>
          {!loading && (
            <table className="table table-bordered table-striped">
              <thead>
                <tr>
                  <th>Status</th>
                  <th>Nr.</th>
                  <th>Izrakstīts</th>
                  <th>Apmaksa</th>
                  <th>Par pasūtijumu</th>
                  <th className="text-sm-right">Summa, &euro;</th>
                </tr>
              </thead>
              <tbody>
                {items.map(({
                  status: {label, style},
                  number,
                  invoiceCreatedAt,
                  invoiceExpiresAt,
                  daysLate,
                  campaign,
                  sum
                }, idx) => 
                  <tr key={idx}>
                    <td>
                      <span className="badge" style={style}>{label}</span>
                    </td>
                    <td>{number}</td>
                    <td>{formatDate(invoiceCreatedAt)}</td>
                    <td>
                      {formatDate(invoiceExpiresAt)}
                      {daysLate && <strong className="text-danger float-right">{daysLate}</strong>}
                    </td>
                    <td>{campaign}</td>
                    <td className="text-sm-right">{sum}</td>
                  </tr>
                )}
              </tbody>
            </table>
          )}
        </Loader>
      </div>
    )
  }
};




// WEBPACK FOOTER //
// ./src/scenes/Profile/Invoices/index.js